<template>
  <div class="inline-flex">
    <slot name="button" :set-show="setShow" :show="show">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-teal-500 cursor-pointer"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        @click="setShow(true)"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
        <polyline points="11 12 12 12 12 16 13 16" />
      </svg>
    </slot>
    <Portal v-if="show" to="app-dialog">
      <VModal ref="modal" @modal:hidden="setShow(false)">
        <div class="w-full max-w-lg mx-auto">
          <div class="rounded shadow-xs w-full max-w-6xl mx-auto" @click.stop>
            <div class="rounded shadow-lg bg-white overflow-hidden">
              <div class="px-4 sm:px-6 py-5 border-t-4 bg-teal-100 border-teal-500">
                <div class="flex items-center justify-between">
                  <div class="flex justify-between items-center flex-1">
                    <h1 class="text-sm flex items-center space-x-2 text-teal-800">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-8 w-8 text-teal-300 cursor-pointer inline-flex"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <circle cx="12" cy="12" r="9" />
                        <line x1="12" y1="8" x2="12.01" y2="8" />
                        <polyline points="11 12 12 12 12 16 13 16" />
                      </svg>
                      <span>
                        {{ title }}
                      </span>
                    </h1>
                    <button
                      class="h-8 w-8 inline-flex items-center justify-center bg-transparent hover:bg-teal-200 bg-opacity-25 focus:outline-none rounded-full"
                      @click="$refs.modal.close()"
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                        <path
                          d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                        4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                        4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                        5.636z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <template>
                <div class="p-4 sm:p-6 space-y-8 border-t border-teal-300">
                  <div v-if="html" v-html="markedOrTextContent" class="prose prose-sm" />
                  <div v-else v-text="markedOrTextContent" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </VModal>
    </Portal>
  </div>
</template>

<script>
import { marked } from 'marked';
import VModal from './Common/VModal.vue';

export default {
  components: { VModal },
  props: {
    title: {
      type: String,
      default: 'Info',
    },
    content: {
      type: String,
      required: true,
    },
    html: Boolean,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    markedOrTextContent() {
      if (!this.html) {
        return this.content;
      }

      return marked(this.content);
    },
  },
  methods: {
    setShow(value) {
      this.show = Boolean(value);
    },
  },
};
</script>
